const FormValueRadioConfig = {
  // 类型
  componentType: 'FORM_RADIO_INPUT',
  // 部件显示样式
  widgetConfig: {
    icon: 'x-lib-radio-component',
    text: '单选框',
    optionTitle: true,
    description: '用于从预设的选项中进行单选'
  },
  componentConfig: {
    uuid: `32bit uuid`,
    width: 12, // 3, 6, 9, 12
    height: 1,
    render: {
      ide: 'FormValueRadio',
      edit: 'FormValueRadio',
      read: 'FormValueRadio'
    },
    label: '单选框',
    multicolor: true,
    lineChooseNum: 6,
    chooseOptions: [
      {
        checked: false,
        color: '#027aff',
        id: randomCode(),
        label: '选项1',
        status: 'ENABLE'
      },
      {
        checked: false,
        color: '#027aff',
        id: randomCode(),
        label: '选项2',
        status: 'ENABLE'
      },
      {
        checked: false,
        color: '#027aff',
        id: randomCode(),
        label: '选项3',
        status: 'ENABLE'
      }
    ],
    chooseType: 'SINGLE',
    customDefaultKey: 'selectDefaultValue',
    methods: {
      lcInitData: {
        edit: (...args) => {
          console.log(args)
        }
      },
      lcConvertDefaultValue: (config) => {
        return config.selectDefaultValue
      }
    }
  },
  methods: {},
  editorConfig: [
    'INFO',
    'LABEL',
    'LINECHOOSENUM',
    'MULTICOLOR',
    'HIDDEN',
    'READONLY',
    'REQUIRED',
    'EDITONNEW',
    'UNIQUE'
  ]
}
function randomCode() {
  const codes = 'ABCDEFGHIJKLMNOPQRSTUVEXYZabcdefghijklmnopqrstuvwxyz1234567890'
  let randomCode = ''
  for (let i = 0; i < 5; i++) {
    let index = parseInt(Math.random() * (codes.length - 0 + 1) + 0, 10)
    randomCode += codes.charAt(index)
  }
  return randomCode
}
export default FormValueRadioConfig
